import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { Conversation } from '../../../services/conversation';

@Component({
  selector: 'app-conversation-details',
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatTableModule, MatPaginatorModule,
    MatSortModule, MatInputModule, MatFormFieldModule, MatButtonModule,
    MatIconModule, MatCardModule, MatDatepickerModule, MatNativeDateModule
  ],
  templateUrl: './conversation-details.component.html',
  styleUrls: ['./conversation-details.component.scss']
})
export class ConversationDetailsComponent implements OnInit {

@Input() globalStartDate!: Date;
@Input() globalEndDate!: Date;
  displayedColumns: string[] = ['conversation_id', 'category', 'satisfied', 'not_satisfied', 'total', 'actions'];
  dataSource = new MatTableDataSource<any>([]);
  
 startDate = new Date();
  endDate = new Date();

 

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private conversationService: Conversation) {
    this.startDate.setDate(this.endDate.getDate() - 7);
  }

  ngOnInit() {
    this.fetchDetails();
  }
  // This lifecycle hook detects when the parent changes the dates
ngOnChanges(changes: SimpleChanges) {
  if (changes['globalStartDate'] || changes['globalEndDate']) {
    this.startDate = this.globalStartDate;
    this.endDate = this.globalEndDate;
    this.fetchDetails(); // Your existing fetch/load function
  }
}

  fetchDetails() {
    const start = this.startDate.toISOString().split('T')[0];
    const end = this.endDate.toISOString().split('T')[0];

    // Note: Ensure your service has getConversationDetails mapping to '/conversation-details'
    this.conversationService.getConversationDetails(start, end).subscribe(res => {
      this.dataSource.data = res.data || [];
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  downloadCSV() {
    const data = this.dataSource.filteredData;
    const headers = ['Conversation ID', 'Category', 'Satisfied', 'Not Satisfied', 'Total'];
    const csv = [
      headers.join(','),
      ...data.map(r => `${r.conversation_id},${r.category},${r.satisfied_count},${r.not_satisfied_count},${r.total_interactions}`)
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `conversation_details_${this.startDate}.csv`;
    a.click();
  }
}
